import { Call } from "app/models/call";

export class CallFilterOptions {

  public createdRange: Date[];
  public problemTemplateIds: Array<number>;
  public status: Call.Status;
  public number: string;
  public author: string;
  public isConfirmed?: boolean;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/dto/callFilterOptions.ts